// extracted by mini-css-extract-plugin
module.exports = {"new":"_id_new_ar9Ux","favorite":"_id_favorite_3TYy3","thumb":"_id_thumb_19BFB","image":"_id_image_1sLXC"};